import {sync} from '@src/js/darkrogua.drimond.js';
$('.reviews-items').owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    margin: 5,
    items: 3,
    autoplay: true,
    autoHeight: false,
    responsive: {
        1600: {
            items: 3,
            margin: 30,
        },
        992: {
            items: 2,
            margin: 30,
        },
        0: {
            items: 1,
            margin: 20,
        }
    }
});
if($('#_ReviewsLink').length)
window.Reviews = new Vue({
    el: '#_ReviewsLink',
    delimiters: ['${', '}'],
    data: {
        ajax_process: false,
        form: false,
        page: 1,
        send: {
            name: '',
            email: '',
            text: '',
            category: '',
            item_id: '',
            language: 'ru',
            rating: '0',
            site_id: '',
        },
        warnings: {
            messages:[],
            badfields:[],
            success: false
        },
    },
    mounted: function () {
        this.send.site_id = $('meta[name="site_id"]').attr('content');
        this.send.language = $('html').attr('lang');
        this.send.item_id = $('#_ReviewsLink[item_id]').attr('item_id');
        this.send.category = $('#_ReviewsLink[category]').attr('category');
    },
    watch: {

    },
    methods: {
        cleanForm: function() {
            this.send.name =  ''
            this.send.email = ''
            this.send.text =  ''
            this.send.rating = 0
            this.warnings.success = false
            this.form = false
        },
        loadReviews: function() {
            var $this = this;
            var page = $('.reviewsCircle-reviewsMoreBtn').attr('page');
            sync(this, {
                method: 'Reviews@loadReviews',
                beforeSend: function(){
                    this.ajax_process = true;
                },
                data: {
                    language: $this.send.language,
                    category: $this.send.category,
                    item_id: $this.send.item_id,
                    page: page,
                },
                success: function (data) {

                    if(!data) return;
                    $('.reviewsCircle-reviewsUsers').append(data.html);
                    if (page == data.last_page) {
                        $('.reviewsCircle-reviewsMoreBtn').fadeOut();
                    } else {
                        $('.reviewsCircle-reviewsMoreBtn').attr('page', parseInt(page)+1);
                    }
                    $this.ajax_process = false;
                },
            });
        },

        sendData: function() {

            var $this = this;
            sync(this, {
                method: 'Reviews@send',
                beforeSend: function(){
                    this.ajax_process = true;
                    //$this.preloaderShow();
                },
                data:  $this.send,
                success: function (data) {
                    if(!data) return;

                    $this.warnings.messages = data.messages;
                    $this.warnings.badfields = data.badfields;
                    $this.warnings.success = data.success;
                    if(data.success){
                        // $this.cleanForm();
                        setTimeout(function() {
                            $('.reviews-form').hide();
                            $this.cleanForm();

                        }, 2000);
                        // refreshForm(2000);
                    }
                    $this.ajax_process = false;
                },
            });

        }
    }
});

$('.reviewsCircle-readFull a').on('click', function() {
    $(this).parent().prev('.reviewsCircle-reviewText').addClass('active');
    $(this).hide();
});
